// local variables
const local = {
  s3: {
    BUCKET: 'YOUR_DEV_S3_UPLOADS_BUCKET_NAME',
  },
  api: {
    ENDPOINT: 'http://localhost:3000/local',
  },
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_ZrQZ7LeL3',
    APP_CLIENT_ID: '5lq8uad5ras10h4pilk7umm47u',
    IDENTITY_POOL_ID: 'us-east-1:80cff5ed-ba2e-4bef-89e4-4edcc6cfd8fe',
  },
};

// dev variables
const dev = {
  s3: {
    BUCKET: 'YOUR_DEV_S3_UPLOADS_BUCKET_NAME',
  },
  api: {
    ENDPOINT: 'https://dev-v2.api.mymedhistory.com',
  },
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_ZrQZ7LeL3',
    APP_CLIENT_ID: '5lq8uad5ras10h4pilk7umm47u',
    IDENTITY_POOL_ID: 'us-east-1:80cff5ed-ba2e-4bef-89e4-4edcc6cfd8fe',
  },
};

// stage variables
const stage = {
  s3: {
    BUCKET: 'YOUR_DEV_S3_UPLOADS_BUCKET_NAME',
  },
  api: {
    ENDPOINT: 'https://test-v2.api.mymedhistory.com',
  },
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_OFBVC1Dz5',
    APP_CLIENT_ID: '7h7cudfdspuq7cjkqi0d3jf07f',
    IDENTITY_POOL_ID: 'us-east-1:5a9e5188-38fc-4337-916c-1536979ba26a',
  },
};

// prod variables
const prod = {
  s3: {
    BUCKET: 'YOUR_DEV_S3_UPLOADS_BUCKET_NAME',
  },
  api: {
    ENDPOINT: 'https://v2.api.mymedhistory.com',
  },
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_mzr4UiGja',
    APP_CLIENT_ID: 't07toti6qekel1ohs30lipike',
    IDENTITY_POOL_ID: 'us-east-1:da1d3d93-0aa0-49cb-94ee-ca0d99d15906',
  }
};

const config =
  process.env.REACT_APP_STAGE === 'prod'
    ? prod
    : process.env.REACT_APP_STAGE === 'stage'
    ? stage
    : process.env.REACT_APP_STAGE === 'dev'
    ? dev
    : local;

const sharedObj = {
  ...config,
};
export default sharedObj;
